module.exports = __webpack_public_path__ + "img/hzjd5.b3d32890.jpg";